module.exports = "/_next/static/images/avatar_3-4d205318ba0c4764b7c46f2929d0dd74.png";